import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { BasicInfoGrid, Column, Item } from './CompanyGrid';
import { WWWCompanyDocument } from '../../../common/documents/WWWCompanyDocument';
import { Help } from '../Help';
import { useUser } from '../../context/useUser';
import { CompanyAccordion } from './CompanyAccordion';
import { nextApiRequest } from '../../lib/utils';
import { Button } from '../Button';
import styled from 'styled-components';

interface CompanyPrivateFieldsProps {
  company: WWWCompanyDocument;
}

export const CompanyPrivateFields = ({ company }: CompanyPrivateFieldsProps) => {
  const user = useUser();
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [yearlyBuys, setYearlyBuys] = useState<number | null>(null);

  const handleEdit = async () => {
    setLoading(true);

    const { status } = await nextApiRequest('/api/v1/www/company/private-edit', {
      companyID: company.companyID,
      yearlyBuys: yearlyBuys || company.privateFields.yearlyBuys || null,
    });

    if (status !== 'ok') console.error('Failed to save private fields', status);

    setLoading(false);
  };

  if (!user.isLoggedIn) return null;

  return (
    <CompanyAccordion
      title="Omat tiedot"
      content={
        <>
          <BasicInfoGrid>
            <Column>
              <Item>
                <TextField
                  label="Vuosiostot"
                  variant="outlined"
                  type="number"
                  style={{ width: 512 }}
                  InputProps={{ inputProps: { min: 0 } }}
                  value={yearlyBuys || company.privateFields.yearlyBuys || ''}
                  onChange={(event) => setYearlyBuys(parseFloat(event.target.value))}
                />
                <Help>Tämä kenttä ja sen arvo näkyvät vain oman tilisi käyttäjille.</Help>
              </Item>
            </Column>
          </BasicInfoGrid>
          <Actions>
            <Button loading={loading} onClick={handleEdit}>
              Tallenna
            </Button>
          </Actions>
        </>
      }
      onChange={(_, state) => setOpen(state)}
      expanded={open}
    />
  );
};

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
  padding-top: 0;
`;
